import { render, staticRenderFns } from "./informationPrice.vue?vue&type=template&id=64f59252&"
import script from "./informationPrice.vue?vue&type=script&lang=js&"
export * from "./informationPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports